
import { defineComponent } from "vue";
import PlanOrderResultJournal from "@/components/journals/PlanOrderResultJournal/PlanOrderResultJournal.vue";
import PlanPanelResultJournal from "@/components/journals/PlanPanelResultJournal/PlanPanelResultJournal.vue";
import PlanContainerResultJournal from "@/components/journals/PlanContainerResultJournal/PlanContainerResultJournal.vue";
import DxButton from "devextreme-vue/button";
import router from "@/router";
import api from "@/services/api";
import { PlanState } from "./enums";
import store from "@/store";

export default defineComponent({
  components: {
    PlanOrderResultJournal,
    PlanPanelResultJournal,
    PlanContainerResultJournal,
    DxButton,
  },
  props: {
    parentModel: { required: true },
    isCalculation: { required: true },
  },
  computed: {
    isPlanCompleted() {
      return this.parentModel.state === PlanState.Completed;
    },
    isPlanNotFound() {
      return this.parentModel.state === PlanState.NotFound;
    },
  },
  methods: {
    onButtonClick() {
      if (this.loading)
        this.onStop();
      else this.onGenerateReport();
    },
    onStop() {
      this.stopping = true;
      this.loading = false;
    },
    onGenerateReport() {
      router.push({
        name: "loadingReport",
        params: {
          planId: `${this.parentModel.id}`,
          planDescription: `${this.parentModel.name}`,
        },
      });
    },
    async getSchemeCount(planId: any){
      const { data } = await api.get(
        `/LoadingReport/GetSchemeCount`,
        {
          params: {
            planId: planId,
          },
        }
      );
      return data;
    },
    async onDownload() {
      const reportData = (store as any).state.reportData.reportData;
      let schemeCount = await this.getSchemeCount(this.parentModel.id);

      if (schemeCount) {
        const time = Math.round(2 * schemeCount);
        this.timeMessage = time > 60 
          ? "\nПриблизительное время формирования отчета - " + Math.floor(time/60) + " мин " + Math.round(time%60) + " сек."
          : "\nПриблизительное время формирования отчета - " + Math.round(time%60) + " сек."
      }
      else {
        this.timeMessage = "";
      }

      this.loading = true;
      this.stopping = false;
      let startTime = new Date().getTime();
      const { data } = await api.get(`/LoadingReport/GetReport`, {
        responseType: "blob",
        params: {
          planId: `${this.parentModel.id}`,
        },
      });
      if(this.stopping)
        return;
      let blob = new Blob([data], { type: "application/octet-stream" });
      let link = document.createElement("a");
      if(this.stopping)
        return;
      link.href = window.URL.createObjectURL(blob);
      if(this.stopping)
        return;
      link.download = `Report.pdf`;
      link.click();
      link.remove();
      this.loading = false;
      this.timeMessage="";
      let endTime = new Date().getTime();

      if (this.schemeCount != 0) {
        const temp = {
          data: {
            generationTime: reportData.generationTime ? reportData.generationTime : null,
            generationTimePdf: (endTime - startTime) / (1000 * schemeCount),
          },
        };
        store.dispatch("reportData/setReportData", temp);
      }
    },
  },
  data() {
    return {
      stopping: false,
      loading: false,
      timeMessage: "",
    };
  },
});
